import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { resetState } from './managerMeetingSlice';

const ManagerMeetingsPage = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(resetState())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Box component={'div'} id='manager-meeting-page' sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Outlet />
        </Box>

    )
}

export default ManagerMeetingsPage